import React from "react"
import {
  Card,
  CardBody,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap"
import ProviderIPsStock from "./ProviderIPsStock"
import ProviderConsumptionReportList from "pages/Provider/Reports/ConsumptionReport"

const DashboardTableTabs = ({
  provIpsStock,
  onCategoryChange,
  onProviderIPsAdvancedSearchHandler,
  onProviderIPsStockExport,
}) => {
  const [activeTab, setActiveTab] = React.useState("ips")

  return (
    <Card className="mt-3">
      <CardBody>
        <Nav tabs>
          <NavItem>
            <NavLink
              className={activeTab === "ips" ? "active" : ""}
              onClick={() => setActiveTab("ips")}
            >
              IP Stock
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={activeTab === "consumption" ? "active" : ""}
              onClick={() => setActiveTab("consumption")}
            >
              Consumption
            </NavLink>
          </NavItem>
        </Nav>

        <TabContent activeTab={activeTab} className="pt-3">
          <TabPane tabId="ips">
            {activeTab === "ips" && (
              <ProviderIPsStock
                onCategoryChange={onCategoryChange}
                provIPsStock={provIpsStock}
                onProviderIPsAdvancedSearchHandler={
                  onProviderIPsAdvancedSearchHandler
                }
                onProviderIPsStockExport={onProviderIPsStockExport}
              />
            )}
          </TabPane>
          <TabPane tabId="consumption">
            {activeTab === "consumption" && (
              <ProviderConsumptionReportList from="Dashboard" />
            )}
          </TabPane>
        </TabContent>
      </CardBody>
    </Card>
  )
}

export default DashboardTableTabs
